import React from "react";
import s from '../../../styles/components/onboarding/keyboard-setup/set-keyboard-size-page.module.scss';
import ExternalLink from "../../common/ExternalLink";
import {onboardingImagesSource} from "../../../config/config";
import BackButton from "../../common/BackButton";
import {keyboardWizardStore} from "../../../redux/keyboardWizard/keyboardWizardStore";
import {KeyboardWizardPage} from "../../../redux/keyboardWizard/keyboardWizardTypes";
import {useSetKeyboardSizeLogic} from "./SetKeyboardSize.logic";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/keyboard-wizard';

interface ISetKeyboardSize {
  mode: "fullscreen" | "modal";
}

export default function SetKeyboardSize({mode}: ISetKeyboardSize) {
  const {keyboardConnectionHelp} = useSetKeyboardSizeLogic();

  const step = keyboardWizardStore.getCurrentPage();

  const pngImageSm2x = step === KeyboardWizardPage.SetLowestNote ? onboardingImagesSource.keyboardLeftPortionSmPNG2x : onboardingImagesSource.keyboardRightPortionSmPNG2x;
  const pngImage2x = step === KeyboardWizardPage.SetLowestNote ? onboardingImagesSource.keyboardLeftPortion10keysPNG2x : onboardingImagesSource.keyboardRightPortion10keysPNG2x;
  const pngImageLg2x = step === KeyboardWizardPage.SetLowestNote ? onboardingImagesSource.keyboardLeftPortionLgPNG2x : onboardingImagesSource.keyboardRightPortionLgPNG2x;
  
  const stepClass = step === KeyboardWizardPage.SetLowestNote ? s.leftKey : s.rightKey;
  const hideBackButtonClass = mode === "modal" ? s.hideBackButton : "";

  const onBackButtonClick = () => {
    if (step === KeyboardWizardPage.SetLowestNote) {
      keyboardWizardStore.setCurrentPage(KeyboardWizardPage.ChooseDevice);
    } else if (step === KeyboardWizardPage.SetHighestNote) {
      keyboardWizardStore.setCurrentPage(KeyboardWizardPage.SetLowestNote);
    } else {
      return undefined;
    }
  }

  return (
    <div className={`${s.container} ${stepClass} ${getModeClass(mode)}`}>
      <div className={`${s.back} ${stepClass}`}>
        <BackButton useClassName={`${s.backButton} ${stepClass} ${hideBackButtonClass}`} onClick={onBackButtonClick} analyticsIdentifier={'keyboard-wizard-set-size-back'} analyticsScreenClass={screenClass}/>
      </div>
      <>
        <header><h2>Set keyboard size</h2></header>
        <div className={`${s.image} ${stepClass} ${hideBackButtonClass}`}>
          <picture className={`${s.keyboardImageWrapper} ${stepClass}`}>
            <source srcSet={pngImageSm2x} media={"(orientation: portrait) and (max-width: 480px)"} width={284} height={216} type={"image/png"} />
            <source srcSet={pngImage2x} media={"(max-width: 1299.99px)"} width={304} height={304} type={"image/png"} />
            <source srcSet={pngImageLg2x} media={"(min-width: 1300px)"} width={576} height={440} type={"image/png"} />
            <img src={pngImage2x} className={`${s.keyboardImage} ${stepClass} ${getModeClass(mode)}`} alt={""} width={304} height={304}/>
          </picture>
        </div>
        <div className={s.body}>{getPressNoteText(step)}</div>
        <footer>
          <ExternalLink
            additionalClassName={s.helpLink}
            url={keyboardConnectionHelp.supportLink}
            title={"Keyboard Connection Help"}
            onClick={() => inAppAnalyticsService.onButton_press('keyboard-wizard-set-size-help', {screenClass})}
          />
        </footer>
      </>
    </div>
  );
}

function getPressNoteText(step: KeyboardWizardPage) {
  const side = step === KeyboardWizardPage.SetLowestNote ? "left" : "right";
  return `Press the far ${side} note on your keyboard.`
}

function getModeClass(mode: ISetKeyboardSize["mode"]) {
  switch (mode) {
    case "fullscreen":
      return s.fullscreen;
    case "modal":
      return s.modal;
  }
}
